import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { novo } from '@opendoor/bricks/theme';

import { buildResponsiveStyling, InputSizeProp, SizeToStyleMap } from './helpers/inputSizing';

type LabelProps = {
  error?: boolean;
  sizeVariant?: InputSizeProp;
};

const SIZE_TO_SERIALIZED_STYLES: SizeToStyleMap = {
  '200': css`
    font-size: ${novo.fontSizes['16px']};
    line-height: ${novo.lineHeights['130']};
    letter-spacing: -0.224px;
  `,
  '300': css`
    font-size: ${novo.fontSizes['18px']};
    line-height: ${novo.lineHeights['120']};
    letter-spacing: -0.432px;
  `,
  '400': css`
    font-size: ${novo.fontSizes['20px']};
    line-height: ${novo.lineHeights['120']};
    letter-spacing: -0.48px;
  `,
  '600': css`
    font-size: ${novo.fontSizes['22px']};
    line-height: ${novo.lineHeights['112']};
    letter-spacing: -0.528px;
  `,
};

const Label = styled.label<LabelProps>`
  cursor: pointer;

  /* Typography */
  font-family: ${novo.fonts.sans};
  font-weight: ${novo.fontWeights.medium};

  ${({ sizeVariant }) =>
    buildResponsiveStyling(SIZE_TO_SERIALIZED_STYLES, sizeVariant ?? ['300', '300', '600'])}

  ${(props) =>
    props.error
      ? css`
          color: #bd1111;
        `
      : ''}
`;

export default Label;
